module.exports = __webpack_public_path__ + "img/LinkedIn_icon.e1a45a67.png";